module.exports = __webpack_public_path__ + "img/T2B_rc_12.ec6cef82.png";